import React from 'react';
import clsx from 'clsx';

import styles from './Radio.module.scss';

type RadioProps = {
  className?: string;
  value: string;
  name: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  labelText?: string
};

export const Radio: React.FC<RadioProps> = ({ className, value, name, checked, labelText, onChange, onClick }) => {
  const change = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
  };

  return (
    <div className={clsx(styles.root, className)} onClick={onClick}>
      <label className='d-flex align-items-center'>
        <input className="hidden" type="radio" name={name} value={value} checked={checked} onChange={change} />
        <div className={styles.icon}></div>
        {labelText && <span className={styles.labelText}>{labelText}</span>}
      </label>
    </div>
  );
};
